<div>
  <b>To Email</b>
  <br/>
  <input [value]="supemail" type="text" class="form-control" readonly>
</div>
